export default __webpack_public_path__ + "static/food-offer-517747c5768f9a68d47b645d7808a00c.png";